// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"93408fb3","122":"4ba783b9","130":"e5c1a275","176":"3396bb32","335":"73344019","473":"19a1da9b","488":"787677d6","507":"91401cc9","606":"bb6f474a","661":"d55ec6f0","705":"51428fcf","793":"c872aace","858":"d24d0650","968":"4c7ed877"}[chunkId] + ".chunk.js";
};